import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import TopicCard from "@/components/base/TopicCard";
import StatusBadge from "@/components/base/StatusBadge";
import { topics } from "@/mocks/topics";

export default function FocusSection() {
  const featured = topics.filter((t) => t.featured);
  const main = featured[0];
  const rest = featured.slice(1);

  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <SectionHeading
          eyebrow="今日焦点"
          title="热度最高的三起追踪"
          description="按传播量、讨论密度与依据更新频率综合排序，每项均附证据清单与可信度参考。"
        />
        <Link
          to="/topics"
          className="inline-flex items-center gap-1 whitespace-nowrap font-label text-sm text-primary-700 hover:text-primary-600 cursor-pointer"
        >
          查看全部追踪 <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <TopicCard topic={main} variant="featured" />
        </div>
        <div className="flex flex-col gap-4 lg:col-span-5">
          {rest.map((topic) => (
            <article
              key={topic.id}
              className="rounded-lg border border-background-300 bg-background-100 p-5"
            >
              <div className="flex items-center justify-between gap-3">
                <StatusBadge status={topic.status} />
                <span className="font-label text-[11px] text-foreground-500">{topic.date}</span>
              </div>
              <h3 className="mt-3 font-heading text-lg font-semibold leading-snug text-foreground-950">
                <Link to={`/topic/${topic.id}`} className="cursor-pointer hover:text-primary-700">
                  {topic.title}
                </Link>
              </h3>
              <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                {topic.summary}
              </p>
              <div className="mt-4 flex flex-wrap items-center gap-2">
                {topic.tags.map((tag) => (
                  <span
                    key={tag}
                    className="rounded-md border border-background-300 bg-background-200/70 px-2 py-0.5 font-label text-[11px] text-foreground-600"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </article>
          ))}
          <div className="flex flex-1 items-center justify-between gap-4 rounded-lg border border-dashed border-primary-300 bg-primary-50/60 p-5">
            <div>
              <p className="font-heading text-sm font-semibold text-foreground-900">有新的线索？</p>
              <p className="mt-1 text-xs text-foreground-600">提交原始素材，我们帮你梳理时间线。</p>
            </div>
            <Link
              to="/about"
              className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-md border border-primary-400 px-3 py-2 font-label text-xs text-primary-700 transition-colors hover:bg-primary-100 cursor-pointer"
            >
              投稿线索
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}